export default __webpack_public_path__ + "static/media/fonts/salesforce.5d4da6db.svg";